// src/components/portal/PortalRoleSelect.js
// Shown when a logged-in user has BOTH a portal role (funder/supervisor)
// AND a learner role in the system.
// Shows two buttons: "My Learner Dashboard" and "Manage My Learners"
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import tpcLogo from "../../images/TPC-logo-light.png";
import "./Portalauth.css";

export default function PortalRoleSelect() {
const navigate = useNavigate();
const auth     = getAuth();
const [session, setSession] = useState(null);

useEffect(() => {
let s = null;
try {
    const portalUser = JSON.parse(sessionStorage.getItem("portalUser") || "null");
    const role = portalUser?.role || sessionStorage.getItem("portalRole") || "";
    const email = portalUser?.email || sessionStorage.getItem("portalEmail") || "";
    if (role && email) {
    s = {
        email,
        isFunder: role === "funder",
        isSupervisor: role === "supervisor",
    };
    }
} catch {
    s = null;
}
if (!s) {
    navigate("/", { replace: true });
    return;
}
setSession(s);
}, [navigate]);

function handleLearnerDashboard() {
// Navigate to the existing learner dashboard
navigate("/learner-dashboard", { replace: true });
}

function handleManageLearners() {
// Navigate to the appropriate portal dashboard
if (session?.isFunder) {
    navigate("/funder-dashboard", { replaces: true });
} else if (session?.isSupervisor) {
    navigate("/supervisor-dashboard", { replace: true });
} else {
    navigate("/funder-dashboard", { replace: true });
}
}

async function handleSignOut() {
["portalUser", "portalRole", "portalEmail", "portalFunderId", "portalFunderDoc", "portalSupervisorId", "portalSupervisorDoc", "portalIsAlsoLearner"].forEach((key) => {
    sessionStorage.removeItem(key);
});
await signOut(auth);
navigate("/", { replace: true });
}

const manageLabel = session?.isFunder ? "Manage My Learners" : "My Supervisor Dashboard";
const manageIcon = session?.isFunder ? "🏢" : "👤";

return (
<div className="portal-role-page">
    <div className="portal-role-card">
    <img src={tpcLogo} alt="TPC" className="portal-role-card__logo" />

    <h1 className="portal-role-card__title">Welcome Back</h1>
    <p className="portal-role-card__sub">
        We found that you have access to multiple areas of the TPC platform.
        <br />Where would you like to go?
    </p>

    <div className="portal-role-card__divider" />

    {/* Learner Dashboard button */}
    <button
        type="button"
        className="portal-role-btn portal-role-btn--navy"
        onClick={handleLearnerDashboard}
    >
        <span style={{ fontSize: 22 }}>📚</span>
        My Learner Dashboard
    </button>

    {/* Funder / Supervisor Dashboard button */}
    <button
        type="button"
        className="portal-role-btn portal-role-btn--gold"
        onClick={handleManageLearners}
    >
        <span style={{ fontSize: 22 }}>{manageIcon}</span>
        {manageLabel}
    </button>

    <button
        type="button"
        className="portal-role-card__signout"
        onClick={handleSignOut}
    >
        Sign out
    </button>
    </div>
</div>
);
}
